export const ICON_DIMENSION = 16;
